export const REDO_REASON_OPTIONS = [
  'Dr. RX Change',
  'Patient Change',
  'Optician Error',
  'Lab Error',
  'Edging Error',
] as const;

export type RedoReason = (typeof REDO_REASON_OPTIONS)[number];

export const PRIORITY_REDO_REASONS: RedoReason[] = [
  'Optician Error',
  'Lab Error',
  'Edging Error',
];

export function isPriorityRedoReason(reason?: string): boolean {
  return PRIORITY_REDO_REASONS.includes(reason as RedoReason);
}
